import { Component } from '@angular/core';

@Component({
  selector: 'series-icon',
  standalone: true,
  imports: [],
  templateUrl: './series.component.html',
  styleUrl: './series.component.scss'
})
export class SeriesIcon {

}
